var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.hasModule
    ? _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("w-switch", {
                attrs: {
                  value: _vm.isEnabled,
                  label: _vm.$ct("price-category-sales-dates-enabled"),
                },
                on: {
                  input: function ($event) {
                    return _vm.toggle()
                  },
                },
              }),
            ],
            1
          ),
          _vm.isEnabled
            ? _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("w-date-picker", {
                    attrs: {
                      "max-date": _vm.endDate,
                      disabled: _vm.startDate == null,
                      value: _vm.startDate,
                      fancy: "",
                      label: _vm.$ct("start-date"),
                    },
                    on: {
                      input: function ($event) {
                        return _vm.setStartDate($event)
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.isEnabled
            ? _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("w-date-picker", {
                    attrs: {
                      "min-date": _vm.startDate,
                      disabled: _vm.endDate == null,
                      value: _vm.endDate,
                      fancy: "",
                      label: _vm.$ct("end-date"),
                    },
                    on: {
                      input: function ($event) {
                        return _vm.setEndDate($event)
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }